<app-scroll-top></app-scroll-top>
<div class="data-protection-bloc">
    <div class="container content">
        <div id="accordion">
            <div class="py-5">
                <div class="text-uppercase py-3">
                    <h3>CHARTE DE PROTECTION DES DONNÉES PERSONNELLES</h3>
                </div>
                <div ngbAccordion>
                    <div ngbAccordionItem>
                        <h4 ngbAccordionHeader>
                            <button ngbAccordionButton>GÉNÉRALITÉS</button>
                        </h4>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                        <ng-template>
                            <div>
                                <p>Conformément au Règlement Général de Protection des Données, ces présentes mentions
                                    ont pour objectif de vous informer sur notre politique en matière de sécurité, de
                                    protection et de confidentialité des traitements effectués sur les données à
                                    caractère personnel que vous nous confiez sur notre site internet :
                                    <a href="https://thedoorman.immo" target="_blank">www.thedoorman.immo</a>
                                </p>
                                <p>Les données à caractère personnel confiées, par le biais de formulaires ou de
                                    cookies, ne peuvent être transmises à des tiers, sans votre consentement.</p>
                                <p>Plus généralement, toute action entrainant la collecte de données personnelles est
                                    soumise à votre consentement préalable.</p>
                                <p>Sauf votre accord express et dans le cadre de la transmission des éléments
                                    nécessaires à la gestion et au suivi de votre dossier auprès des partenaires
                                    concernés, l’ensemble des données fournies sur notre site internet sont protégées,
                                    et leur confidentialité garantie.</p>
                                <p>Vous avez également la possibilité de vous inscrire gratuitement sur une liste
                                    d’opposition au démarchage téléphonique directement en ligne sur <a
                                        href="http://www.service-public.fr" target="_blank">www.service-public.fr</a>
                                </p>

                            </div>
                        </ng-template>
                            </div>
                        </div>
                    </div>
                    <div ngbAccordionItem>
                        <h4 ngbAccordionHeader>
                            <button ngbAccordionButton>ACCÈS AUX SERVICES</button>
                        </h4>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                        <ng-template>
                            <div>
                                <p>Pour accéder aux services de THE DOOR MAN, vous devez obligatoirement renseigner
                                    certaines données personnelles.</p>
                                <p>Pour certains services, vous serez amené à créer un compte personnel, et choisir un
                                    identifiant et un mot de passe.</p>
                                <p>Les informations demandées au sein des formulaires de notre site internet sont toutes
                                    obligatoires afin :
                                    <br />&nbsp;-&nbsp;De nous permettre de remplir notre mission de Conseiller en immobilier à
                                    votre attention ;
                                    <br />&nbsp;-&nbsp;De vous permettre de créer votre compte personnel ;
                                    <br />&nbsp;-&nbsp;De transmettre vos informations directement à l’un de nos Conseillers
                                    permettant un traitement de votre demande dans les délais les plus courts ;
                                </p>
                                <p>Les mineurs doivent obtenir l’autorisation de leurs parents.</p>
                            </div>
                        </ng-template>
                            </div>
                        </div>
                    </div>
                    <div ngbAccordionItem>
                        <h4 ngbAccordionHeader>
                            <button ngbAccordionButton>Données collectées</button>
                        </h4>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                        <ng-template>
                            <div>
                                <p>Toutes les données que nous vous demandons de renseigner sont utiles et dans votre
                                    intérêt pour nous permettre de vous offrir un service complet.</p>
                                <p>Nous collectons sur notre site internet les données suivantes :</p>
                                <p>Adresse e-mail (qui peut être votre identifiant), votre mot de passe, nom et prénom,
                                    téléphone.</p>
                                <p>Vous devez renseigner une adresse e-mail valide vous appartenant, pas celle d’un
                                    tiers.</p>
                                <p>Certaines données ne sont pas obligatoires et vous pouvez choisir de ne pas les
                                    renseigner, néanmoins pour bénéficier d’un traitement optimisé de votre demande et
                                    d’un service complet, nous vous invitons à remplir un maximum d’informations.</p>
                                <p>Par la suite et en tant que Conseiller en immobilier, nous vous solliciterons afin de
                                    recueillir de plus amples données pour mener à bien notre mission.</p>
                                <p>Ces données sont spécifiques à notre mission que vous nous confiez en signant un
                                    mandat avec l’un de nos Conseillers.</p>
                                <p>Pendant votre navigation sur notre site internet, et afin de vous garantir la
                                    meilleure expérience utilisateur possible, quelques informations peuvent être
                                    collectés par le biais de cookies</p>
                                <p>Voici la liste des cookies que nous utilisons sur notre site internet :</p>
                                <p>Google analytics</p>
                                <p>Certains cookies sont nécessaires à l’utilisation de notre site internet et d’autres
                                    peuvent être désactivé.</p>
                                <p>Google Chrome :
                                    <br />&nbsp;-&nbsp;Desktop & Mobile : <a
                                        href="https://support.google.com/chrome/answer/95647?hl=fr"
                                        target="_blank">https://support.google.com/chrome/answer/95647?hl=fr</a>
                                </p>

                                <p>Mozilla Firefox : <a
                                        href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies-preferences"
                                        target="_blank">https://support.mozilla.org/fr/kb/activer-desactiver-cookies-preferences</a>
                                </p>
                                <p>Microsoft Internet Explorer : <a
                                        href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
                                        target="_blank">https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies</a>
                                </p>
                                <p>Microsoft Edge : <a
                                        href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy"
                                        target="_blank">https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy</a>
                                </p>
                                <p>Apple Safari :
                                    <br />&nbsp;-&nbsp;Desktop : <a
                                        href="https://support.apple.com/kb/PH21411?viewlocale=en_US&locale=en_US"
                                        target="_blank">https://support.apple.com/kb/PH21411?viewlocale=en_US&locale=en_US</a>
                                    <br />&nbsp;-&nbsp;Mobile : <a href="https://support.apple.com/en-us/HT201265"
                                        target="_blank">https://support.apple.com/en-us/HT201265</a>
                                </p>

                                <p>Opera : <a href="http://help.opera.com/Windows/10.20/fr/cookies.html"
                                        target="_blank">http://help.opera.com/Windows/10.20/fr/cookies.html</a></p>

                            </div>
                        </ng-template>
                            </div>
                        </div>
                    </div>
                    <div ngbAccordionItem>
                        <h4 ngbAccordionHeader>
                            <button ngbAccordionButton>Données non-collectées</button>
                        </h4>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                        <ng-template>
                            <div>
                                <p>Nous ne collectons pas de données personnelles sensibles, vos données de connexion
                                    (adresse IP, logs, …), vos données de localisation.</p>
                            </div>
                        </ng-template>
                            </div>
                        </div>
                    </div>
                    <div ngbAccordionItem>
                        <h4 ngbAccordionHeader>
                            <button ngbAccordionButton>Consentement</button>
                        </h4>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                        <ng-template>
                            <div>
                                <p>Les données à caractère personnel collectées vous appartiennent.</p>
                                <p>Aussi, aucune transmission de ces données ne sera faite à des tiers sans votre
                                    consentement expresse. </p>
                            </div>
                        </ng-template>
                            </div>
                        </div>
                    </div>
                    <div ngbAccordionItem>
                        <h4 ngbAccordionHeader>
                            <button ngbAccordionButton>Conservation</button>
                        </h4>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                        <ng-template>
                            <div>
                                <p>Dans le cadre de nos obligations réglementaires, nous conservons vos données à minima
                                    10 ans.</p>
                                <p>Dans le cadre de votre consentement pour bénéficier des offres de THE DOOR MAN et/ou
                                    des offres des partenaires commerciaux de THE DOOR MAN, nous ne conservons vos
                                    données qu’au maximum pendant trois (3) ans. </p>

                            </div>
                        </ng-template>
                            </div>
                        </div>
                    </div>
                    <div ngbAccordionItem>
                        <h4 ngbAccordionHeader>
                            <button ngbAccordionButton>Droit d’accès</button>
                        </h4>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                        <ng-template>
                            <div>
                                <p>Vous pouvez accéder, modifier, ajouter, et supprimer les données renseignées vous
                                    concernant.</p>
                                <p>Vous pouvez vous opposer au traitement de vos données et à l’utilisation de ceux-ci à
                                    des fins commerciales.</p>
                                <p>Pour exercer vos droits, vous devez envoyer courrier postal à l’adresse du siège :
                                </p>
                                <div class="center">
                                    <p><strong>THE DOOR MAN France</strong><br />ZA Du Bel Air<br />3 bis, rue
                                        Barthélemy Thimonnier<br />78120 RAMBOUILLET</p>
                                </div>
                                <p>Ou par email :</p>
                                <div class="center">
                                    <p><a href="mailto:contact@tdm.immo" target="_blank">contact&#64;tdm.immo</a></p>
                                </div>

                            </div>
                        </ng-template>
                            </div>
                        </div>
                    </div>
                    <div ngbAccordionItem>
                        <h4 ngbAccordionHeader>
                            <button ngbAccordionButton>Transmission</button>
                        </h4>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                        <ng-template>
                            <div>
                                <p>En signant avec l’un de nos Conseillers un contrat, vous nous autorisez de fait à
                                    transmettre l’ensemble de vos données nécessaires à la bonne réalisation de la
                                    mission qui vous nous confiez.</p>
                                <p>Cependant, dans le cadre d’un traitement de vos données à caractère personnel à des
                                    fins commerciales, aucune transmission ne sera opérée auprès de partenaires sans
                                    votre consentement.</p>
                                <p>Ces partenaires ont été sélectionnés pour le service qu’ils peuvent vous apporter en
                                    complément de notre mission.</p>
                                <p>Ces partenaires sélectionnés ont leur propre politique de protection des données
                                    personnelles et que notre responsabilité ne pourrait être engagée au-delà de notre
                                    site internet. </p>

                            </div>
                        </ng-template>
                            </div>
                        </div>
                    </div>
                    <div ngbAccordionItem>
                        <h4 ngbAccordionHeader>
                            <button ngbAccordionButton>Sécurité</button>
                        </h4>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                        <ng-template>
                            <div>
                                <p>Nous mettons tout en œuvre pour protéger les données que vous nous confiez.</p>
                                <p>Nos sites de stockage (numérique ou physique) de vos données sont protégés contre des
                                    actions malveillantes (intrusions, virus informatique, vol de mots de passe, etc.)
                                    mais également contre la survenance d’accidents (incendie, inondation, etc.).</p>
                                <p>En cas de défaillance, vous serez avertis dans les 72 heures à partir de la
                                    connaissance de la survenance de l’évènement.</p>
                                <p>Les sauvegardes des données sont régulières et sur des sites de stockage différents.
                                </p>
                                <p>Les traitements statistiques sont anonymisés. </p>

                            </div>
                        </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>
